import { countries_options } from "@/components/Form/CountryPhone/data";
import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { preprocessTextAsyncAutocompleteField } from "@/features/FormCard/utils";
import { z } from "zod";
import { useTranslation } from "react-i18next";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";

const filterD1IssuersSchema = z.object({
  name_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional()
    .nullable(),
  country_contains: z.string().optional(),
  sector_contains: z.string().optional(),
});

export type FilterD1IssuersSchema = z.infer<typeof filterD1IssuersSchema>;

export function FilterD1Issuers() {
  const { t, i18n } = useTranslation(["common", "tables"]);
  const language = i18n.language?.startsWith("en") ? "en" : "fr";

  const fields: Field[] = [
    {
      name: "name_contains",
      label: t(`${Tables.D1_ISSUERS}.columns.name`, {
        ns: "tables",
        defaultValue: "Name",
      }),
      type: "asyncAutocomplete",
      base_url: `${Clients.D1}/${Tables.D1_ISSUERS}`,
      column_name: "name",
    },
    {
      name: "country_contains",
      label: t(`${Tables.D1_ISSUERS}.columns.country_name`, {
        ns: "tables",
        defaultValue: "Country",
      }),
      type: "autocomplete",
      options: countries_options,
    },
    {
      name: "sector_contains",
      label: t(`${Tables.D1_ISSUERS}.columns.sector`, {
        ns: "tables",
        defaultValue: "Sector",
      }),
      type: "select",
      useTranslation: true,
      client: Clients.D1,
      table_name: Tables.D1_ISSUERS,
      language,
      translate_key: "sector",
    },
  ];

  return (
    <FilterTable
      client={Clients.D1}
      schema={filterD1IssuersSchema}
      tableName={Tables.D1_ISSUERS}
      fields={fields}
    />
  );
}
